/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Job } from '../models/job';
@Injectable({
  providedIn: 'root',
})
class JobService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `JobService.JobListParams` containing the following parameters:
   *
   * - `search`: A search term.
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `limit`: Number of results to return per page.
   */
  jobListResponse(params: JobService.JobListParams): __Observable<__StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<Job>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.search != null) __params = __params.set('search', params.search.toString());
    if (params.ordering != null) __params = __params.set('ordering', params.ordering.toString());
    if (params.offset != null) __params = __params.set('offset', params.offset.toString());
    if (params.limit != null) __params = __params.set('limit', params.limit.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/job/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<Job>}>;
      })
    );
  }
  /**
   * @param params The `JobService.JobListParams` containing the following parameters:
   *
   * - `search`: A search term.
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `limit`: Number of results to return per page.
   */
  jobList(params: JobService.JobListParams): __Observable<{count: number, next?: null | string, previous?: null | string, results: Array<Job>}> {
    return this.jobListResponse(params).pipe(
      __map(_r => _r.body as {count: number, next?: null | string, previous?: null | string, results: Array<Job>})
    );
  }

  /**
   * @param data undefined
   */
  jobCreateResponse(data: Job): __Observable<__StrictHttpResponse<Job>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/job/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Job>;
      })
    );
  }
  /**
   * @param data undefined
   */
  jobCreate(data: Job): __Observable<Job> {
    return this.jobCreateResponse(data).pipe(
      __map(_r => _r.body as Job)
    );
  }

  /**
   * @param id A unique integer value identifying this job.
   */
  jobReadResponse(id: number): __Observable<__StrictHttpResponse<Job>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/job/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Job>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this job.
   */
  jobRead(id: number): __Observable<Job> {
    return this.jobReadResponse(id).pipe(
      __map(_r => _r.body as Job)
    );
  }

  /**
   * @param params The `JobService.JobUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this job.
   *
   * - `data`:
   */
  jobUpdateResponse(params: JobService.JobUpdateParams): __Observable<__StrictHttpResponse<Job>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/job/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Job>;
      })
    );
  }
  /**
   * @param params The `JobService.JobUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this job.
   *
   * - `data`:
   */
  jobUpdate(params: JobService.JobUpdateParams): __Observable<Job> {
    return this.jobUpdateResponse(params).pipe(
      __map(_r => _r.body as Job)
    );
  }

  /**
   * @param params The `JobService.JobPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this job.
   *
   * - `data`:
   */
  jobPartialUpdateResponse(params: JobService.JobPartialUpdateParams): __Observable<__StrictHttpResponse<Job>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/job/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Job>;
      })
    );
  }
  /**
   * @param params The `JobService.JobPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this job.
   *
   * - `data`:
   */
  jobPartialUpdate(params: JobService.JobPartialUpdateParams): __Observable<Job> {
    return this.jobPartialUpdateResponse(params).pipe(
      __map(_r => _r.body as Job)
    );
  }

  /**
   * @param id A unique integer value identifying this job.
   */
  jobDeleteResponse(id: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/job/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this job.
   */
  jobDelete(id: number): __Observable<null> {
    return this.jobDeleteResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module JobService {

  /**
   * Parameters for jobList
   */
  export interface JobListParams {

    /**
     * A search term.
     */
    search?: string;

    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;

    /**
     * The initial index from which to return the results.
     */
    offset?: number;

    /**
     * Number of results to return per page.
     */
    limit?: number;
  }

  /**
   * Parameters for jobUpdate
   */
  export interface JobUpdateParams {

    /**
     * A unique integer value identifying this job.
     */
    id: number;
    data: Job;
  }

  /**
   * Parameters for jobPartialUpdate
   */
  export interface JobPartialUpdateParams {

    /**
     * A unique integer value identifying this job.
     */
    id: number;
    data: Job;
  }
}

export { JobService }
